import type { NodeInstance } from '@glueapp/graph-types';
import { HttpRequestLayout } from '@/GraphEditor/drawingLayer/nodeComposition/HttpRequestLayout';

interface Props {
    nodeInstance: NodeInstance;
}

export const HttpRequestNode: React.FC<Props> = ({ nodeInstance }) => {
    return <HttpRequestLayout nodeInstance={nodeInstance} />;
};
